import * as Style from './UserVideo.style';

export * from './UserVideo';
export * from './CircleVideo';

export const Avatar = Style.VideoAvatar;
